import { useTranslation } from 'react-i18next'

import PlainButton from 'app/common/ui-next/plain-button'
import type { IdentifierType } from 'app/common/constants/identifiers'
import allIdentifierTypes from 'app/common/constants/identifiers/all'
import format from 'app/common/constants/identifiers/formats'

import AddIdentifierModal from './add-identifier-modal'

type Props = {
  accountID?: string | null // используется только если bankCardUseFrame === true
  bankCardUseFrame?: boolean
  className?: string
  availableIdentifierTypes?: Array<IdentifierType>
  identifierFormat?: (typeof format)[keyof typeof format]
  createErrorText: (identifierType: IdentifierType | null, identifierCode: string) => string
  onSubmit?: (code: string, identifierType: IdentifierType | null) => Promise<boolean>
  onRefresh?: () => void
  onApprove?: (params: { identifierValue: string }) => Promise<unknown>
  approveInfo: { balance: number; price: number }
}

const AddIdentifierButton = ({
  accountID,
  bankCardUseFrame,
  className,
  availableIdentifierTypes = allIdentifierTypes,
  identifierFormat,
  createErrorText,
  onSubmit,
  onRefresh,
  onApprove,
  approveInfo,
}: Props) => {
  const { t } = useTranslation('identifiers-next')

  return (
    <AddIdentifierModal
      accountID={accountID}
      bankCardUseFrame={bankCardUseFrame}
      availableIdentifierTypes={availableIdentifierTypes}
      identifierFormat={identifierFormat}
      createErrorText={createErrorText}
      onSubmit={onSubmit}
      onRefresh={onRefresh}
      onApprove={onApprove}
      approveInfo={approveInfo}
    >
      {(onClick) => (
        <PlainButton className={className} onClick={onClick}>
          {t('add_identifier_button', 'Добавить идентификатор')}
        </PlainButton>
      )}
    </AddIdentifierModal>
  )
}

export default AddIdentifierButton
